import React, { useContext, useState } from 'react'
import { navigate, Redirect } from "@reach/router"
import Card from '@material-ui/core/Card'
import Modal from '@material-ui/core/Modal'
import { CreateCartoMapContext } from '../../../../../contexts/carto-maps-context'
import { createCartoMapRecord } from "../../../../../../services/backendApi";
import Spinner from '../../../../../presentation/spinner'
import ConfirmContent from './ConfirmContent'
import ErrorContent from './ErrorContent'
import './style.css'

const ConfirmationModal = ({ isOpen, setIsOpen }) => {
    const { accountId, fromDate, toDate, isAllTimeSelected, visualisationName, zonesSelected, resetForm } = useContext(CreateCartoMapContext)
    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSuccesful, setIsSuccessful ] = useState(null)

    const initiateCartoVisualisationCreation = async (zoneIds) => {
        const startTime = isAllTimeSelected ? null : fromDate.toISOString()
        const endTime =  isAllTimeSelected ? null : toDate.toISOString()

        /**
         * When a new record is created in the Visualisations collection.
         * It will trigger the service that creates the visualisation in Carto.
         */
        await createCartoMapRecord(
            accountId,
            visualisationName,
            zoneIds,
            startTime,
            endTime
        )
    }

    const onClickConfirm = async () => {
        setIsLoading(true)
        try {
            if (zonesSelected.zones.length) {
                const zoneIds = zonesSelected.zones.map(zone => zone._id)
                
                await initiateCartoVisualisationCreation(zoneIds)

                setIsLoading(false)
                setIsSuccessful(true)
            }
        } catch (error) {
            setIsSuccessful(false)
            setIsLoading(false)
            console.error(`Error posting the zones ${error}`)
        }
    }

    const onClickCancel = () => {
        resetForm()
        setIsLoading(false)
        setIsSuccessful(null)
        setIsOpen(false)
        navigate(`/customer/${accountId}/visualisations`)
    }

    const handleOnClose = () => {
        if (isSuccesful !== null) return onClickCancel
        return () => setIsOpen(false)
    }

    const renderModalContent =  () => {
        if (isLoading) {
            return (
                <div className="modal-spinner-wrapper">
                   <Spinner size="70" />
                </div>
            )
        }
        if (isSuccesful === true) return <Redirect to={`/customer/${accountId}/visualisations`} />
        if (isSuccesful === false) return <ErrorContent onClose={handleOnClose()} />

        return <ConfirmContent setIsOpen={setIsOpen} onClickConfirm={onClickConfirm}/>
    }

    return (
        <Modal
            open={isOpen}
            onClose={handleOnClose()}
        >
            <Card className="modal-card-wrapper">
               { renderModalContent() }
            </Card>
        </Modal>
    )
}

export default ConfirmationModal